import React, { createContext, useContext } from 'react';

export function createSafeContext<T>(
    contextName: string
): [React.FC<React.PropsWithChildren<{ value: T }>>, () => T, React.Context<T | null>] {
    const Context = createContext<T | null>(null);

    const Provider = (props: React.PropsWithChildren<{ value: T }>) => (
        <Context value={props.value}>{props.children}</Context>
    );

    const useSafeContext = (): T => {
        const context = useContext(Context);
        if (context === null) {
            throw new Error(`use${contextName}Context must be used within a ${contextName}Provider`);
        }
        return context;
    };

    return [Provider, useSafeContext, Context] as const;
}
